import { useAsyncCallback } from 'react-async-hook';
import { useEffect } from 'react';
import { FinanceResponse } from '@upstart/harmony/lib/legos/financingTypes';
import { MessageType } from '@upstart/harmony/lib/legos/websiteTypes';

import FinanceResponseService from '../../services/FinanceResponseService';
import { PageMessage } from '../GlobalUI';
import { parseAsyncError } from '../../util/tsutils';

const DEFAULT_ERROR_MESSAGE = 'Error Cloning Upstart Response';
const useCloneFinanceResponse = () => {
  const asyncCloneFinanceResponse = useAsyncCallback<FinanceResponse>(
    FinanceResponseService.cloneUpstartFinanceResponse,
  );

  useEffect(() => {
    if (asyncCloneFinanceResponse?.error) {
      const errMsg = parseAsyncError(
        asyncCloneFinanceResponse?.error,
        DEFAULT_ERROR_MESSAGE,
      );
      PageMessage({
        type: MessageType.ERROR,
        message: errMsg,
        headline: 'Error',
      });
    }
  }, [asyncCloneFinanceResponse.error]);

  return {
    asyncCloneFinanceResponse,
  };
};

export default useCloneFinanceResponse;
